import type { Permission } from '../../context/RoleContext';

export interface HelpArticle {
    /** URL segment — /help/:slug. Derived from the filename. */
    slug: string;
    title: string;
    category: HelpCategory;
    /** One line shown on the index card and in search results. */
    summary: string;
    /** Lucide icon name; falls back to a generic doc icon if unknown. */
    icon: string;
    /** Sort order within a category. Lower first. */
    order: number;
    /** Hide from users whose role can't act on the article's subject. */
    permission?: Permission;
    /** Optional graphic/interactive block rendered above the prose, e.g. 'flow'. */
    visual?: string;
    /** Markdown body, jargon tokens NOT yet substituted. */
    body: string;
    /** True when this came from the database rather than the bundle. */
    fromDb?: boolean;
}

export const HELP_CATEGORIES = [
    'Start here',
    'Your money',
    'Day to day',
    'Money out',
    'Your setup',
    'App & troubleshooting',
] as const;

export type HelpCategory = (typeof HELP_CATEGORIES)[number];

/**
 * Where articles come from. Two implementations exist and both are live:
 * markdown bundled with the app, and the `help_articles` table. The composite
 * source in ./index.ts layers the database over the bundle, so copy can be
 * edited without a deploy while the app still works offline and still works if
 * the table is empty or unreachable.
 */
export interface HelpSource {
    listArticles(): Promise<HelpArticle[]>;
    getArticle(slug: string): Promise<HelpArticle | null>;
}
